import { FC, useMemo } from 'react';
import cn from 'classnames';
import { ReactComponent as InterceptionIcon } from 'images/icons/interception.svg';

import { useAppSelector } from '../../hooks';
import { Interception } from '../../interfaces/interceptions';
import {
  interceptionDepartmentsSelector,
  interceptionNetworksSelector,
} from '../../store/slices/interception/selectors';

interface InterceptionsCardProps {
  interception: Interception;
  isOpened: boolean;
}

const InterceptionsCard: FC<InterceptionsCardProps> = ({
  interception,
  isOpened = false,
}) => {
  const { summary, duration, network_id, protocol, frequency } = interception;
  const networks = useAppSelector(interceptionNetworksSelector);
  const departments = useAppSelector(interceptionDepartmentsSelector);
  const selectedNetworkName = useMemo(
    () => networks.find((network) => network.id === network_id)?.name,
    [networks, network_id]
  );
  const selectedDepartmentName = useMemo(() => {
    const network = networks.find((network) => network.id === network_id);
    if (network) {
      return departments.find(
        (department) => department.id == network.department_id
      )?.name;
    }
  }, [networks, network_id, departments]);
  return (
    <div
      className={cn(
        'flex flex-col py-4 px-4 gap-4 justify-center bg-dark cursor-pointer',
        {
          'border border-solid border-bright_product rounded-[10px]': isOpened,
        }
      )}
    >
      <div className="flex justify-between">
        <div className="flex justify-center items-center gap-2">
          <InterceptionIcon />
          <div className="font-bold">
            {frequency} <span className="text-[#9599a6]">({protocol})</span>
          </div>
          <div className="text-[#9599a6] text-sm">
            {selectedNetworkName}, {selectedDepartmentName}
          </div>
        </div>
        <div className="text-sm">{duration}</div>
      </div>
      <div>{summary}</div>
    </div>
  );
};

export default InterceptionsCard;
